import React from 'react';
import PanelPasajero from './paquetes-checkout-panel-pasajero';

const Pasajeros = (props) => {
  let indicePasajero = 0;
  const armarHabitaciones = (tipo, pasajeros, nroHabitacion) => {
    const listaPasajeros = [];
    for (let pasajero = 1; pasajero <= pasajeros; pasajero++) {
      listaPasajeros.push(
        <PanelPasajero
          key={indicePasajero}
          nacionalidades={props.nacionalidades}
          pasajeros={props.pasajeros}
          actualizarFechaNacimientoPasajeros={props.actualizarFechaNacimientoPasajeros}
          actualizarVencimientoPasaporte={props.actualizarVencimientoPasaporte}
          actualizarPasajeros={props.actualizarPasajeros}
          tipo={tipo}
          indice={indicePasajero}
          title={`${tipo} ${pasajero} - Habitacion ${nroHabitacion}`}
          proveedorId={props.proveedorId}
        />,
      );
      indicePasajero++;
    }
    return listaPasajeros;
  };
  const armarPaneles = () => props.habitaciones.map((habitacion, numeroHabitacion) => {
    const listaPasajeros = [];
    const nroHabitacion = numeroHabitacion + 1;
    const listaAdultosPorHabitacion = armarHabitaciones(
      'Adulto',
      habitacion.adultos,
      nroHabitacion,
    );
    const listaMenoresPorHabitacion = armarHabitaciones(
      'Menor',
      habitacion.menores.length,
      nroHabitacion,
    );
    listaPasajeros.push(listaAdultosPorHabitacion);
    listaPasajeros.push(listaMenoresPorHabitacion);
    return listaPasajeros;
  });

  return (
    <div>
      {armarPaneles()}
    </div>
  );
};

export default Pasajeros;
